// extracted by mini-css-extract-plugin
export default {"controlButton":"cogfC5","hidden":"mmqzPB","container":"d9mlS5","frame":"nfTT9S"};